import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from 'vue';
import {Uploader} from 'vant';
import {base64toFile, getPhoneVersions} from '@/libs/utils';
import {getTestWechatSDKSign, getWechatSDKSign} from '@/api/miscellaneous';


export default /*#__PURE__*/_defineComponent({
  __name: 'Upload',
  props: {
    ...Uploader.props,
},
  setup(__props, { expose }) {
  expose();

const props = __props



const isWeChat = ref(getPhoneVersions().weixin);

onMounted(() => {
    getWechatSDKSign({url: location.href.split('#')[0]}).then(res => {
        // const {appId, timestamp, nonceStr, signature} = res;
        const {appId, timestamp, nonceStr, signature} = res;
        wx.config({
            debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
            appId, // 必填，公众号的唯一标识
            timestamp, // 必填，生成签名的时间戳
            nonceStr, // 必填，生成签名的随机串
            signature, // 必填，签名
            jsApiList: ['chooseImage', 'getLocalImgData'], // 必填，需要使用的 JS 接口列表
            openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表
        });
    });
});

const choseImage = async () => {
    wx.chooseImage({
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: function (res: any) {
            const localIds = res.localIds; // 返回选定照片的本地 ID 列表，localId可以作为 img 标签的 src 属性显示图片
            const imgList = Promise.all(localIds.map((el: string) => getImage(el)));
            imgList.then(res => {
                props.afterRead && props.afterRead(res);
            });
        },
    });
};

const getImage = (id: string) => {
    return new Promise((resolve, reject) => {
        wx.getLocalImgData({
            localId: id, // 图片的localID
            success: function (res: any) {
                let base64Str = '';
                /**
                 * 判断是否是安卓环境
                 * */
                if (getPhoneVersions().android) {
                    base64Str = 'data:image/png;base64,' + res.localData;
                } else {
                    base64Str = res.localData;
                }
                const data = base64toFile(base64Str, new Date().getTime().toString());
                resolve({content: base64Str, file: data});
            },
            fail: function (res: any) {
                reject(res);
            },
        });
    });
};

const __returned__ = { props, isWeChat, choseImage, getImage, onMounted, ref, Uploader, base64toFile, getPhoneVersions, getTestWechatSDKSign, getWechatSDKSign }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})